import { Box, CircularProgress, Typography } from "@material-ui/core";
import { ParentSize } from "@visx/responsive";

import Chart from "../../../../../Chart/";
import useTimeseriesSimple from "../../../../../../hooks/useTimeseriesSimple";
import useQueryState from "../../../../../../hooks/useQueryState";

const Timeseries = ({ type, season }: { type: string; season?: string }) => {
  const { series, option, isLoadingAnomaly, isLoadingClimate } =
    useTimeseriesSimple({ type, season });

  const {
    queryState: {
      ui: { mapSidebar, mainSidebar },
    },
  } = useQueryState();

  const isLoading = type === "climate" ? isLoadingClimate : isLoadingAnomaly;

  if (isLoading) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (
    series.length === 0 ||
    series.every((s) => !s.data || s.data.length === 0)
  ) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="caption" color="textSecondary">
          There is no data to display
        </Typography>
      </Box>
    );
  }

  return (
    <ParentSize>
      {({ width, height }) => {
        if (!width || !height) return null;
        return (
          <Chart
            width={`calc(100vw - ${mainSidebar ? "290px" : "100px"} - ${mapSidebar ? "320px" : "0px"}`} // TODO
            height={height}
            option={{ ...option, series }}
            onLegendSelectChanged={() => {}}
          />
        );
      }}
    </ParentSize>
  );
};

export default Timeseries;
